//region block: pre-declaration
//endregion
function webOrigin() {
  return window.location.origin;
}
//region block: exports
export {
  webOrigin as webOrigin32whb6fx4rie,
};
//endregion

//# sourceMappingURL=WebOrigin.js.mjs.map
